module.exports = __webpack_public_path__ + "static/media/EP01@s.af6e0470.jpg";